import type { ReactNode } from 'react'

export function MetricCard({ label, value, tone }: { label: string; value: number; tone: 'blue' | 'teal' | 'gold' | 'slate' }) {
  return (
    <div className={`rounded-3xl border p-4 shadow-sm ${tone === 'blue' ? 'border-blue-200 bg-blue-50' : tone === 'teal' ? 'border-teal-200 bg-teal-50' : tone === 'gold' ? 'border-amber-200 bg-amber-50' : 'border-slate-200 bg-slate-50'}`}>
      <p className="text-xs font-black uppercase tracking-[0.18em] text-slate-500">{label}</p>
      <p className="mt-2 font-brand text-3xl font-bold text-slate-900">{value}</p>
    </div>
  )
}

export function MetricMini({ label, value }: { label: string; value: string }) {
  return (
    <div className="rounded-2xl border border-[color:var(--training-border)] bg-white px-4 py-3">
      <p className="text-xs font-black uppercase tracking-[0.18em] text-slate-400">{label}</p>
      <p className="mt-1 text-lg font-bold text-slate-900">{value}</p>
    </div>
  )
}

export function InfoLine({ label, value }: { label: string; value: string }) {
  return (
    <div className="mt-3">
      <p className="text-xs font-black uppercase tracking-[0.18em] text-slate-400">{label}</p>
      <p className="mt-1 text-sm text-slate-700">{value}</p>
    </div>
  )
}

export function Pill({ children, tone = 'slate' }: { children: ReactNode; tone?: 'slate' | 'blue' | 'gold' | 'rose' }) {
  return (
    <span className={`rounded-full px-3 py-1 text-[11px] font-black uppercase tracking-[0.16em] ${tone === 'blue' ? 'bg-blue-100 text-blue-700' : tone === 'gold' ? 'bg-amber-100 text-amber-800' : tone === 'rose' ? 'bg-rose-100 text-rose-700' : 'bg-slate-100 text-slate-600'}`}>
      {children}
    </span>
  )
}

export function EmptyCard({ message }: { message: string }) {
  return <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-4 text-sm text-slate-500">{message}</div>
}
